(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('planning', {
            parent: 'entity',
            url: '/planning',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning.html',
                    controller: 'PlanningController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('planning-detail', {
            parent: 'entity',
            url: '/planning/{planType}/{id}',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning Detail'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning-detail.html',
                    controller: 'PlanningDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Planning', function($stateParams, Planning) {
                    return Planning.get({planType: $stateParams.planType, id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'planning',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('planning.versions', {
            parent: 'entity',
            url: '/planning/versions/{planType}/{id}',
            data: {
            	authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning Versions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning-versions.html',
                    controller: 'PlanningVersionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Planning', function($stateParams, Planning) {
                    return Planning.get({planType: $stateParams.planType, id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'planning',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('planning-detail-version', {
        	parent: 'entity',
            url: '/planning/{planType}/{id}/{internalVersion}',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Planning details version'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/planning/planning-detail.html',
                    controller: 'PlanningDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Planning', function($stateParams, Planning) {
                    return Planning.get({planType: $stateParams.planType, id : $stateParams.id, internalVersion : $stateParams.internalVersion}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'planning',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();
